import { getParcels, toApiError } from "@/shared/providers/api";
import type { Paginated, Parcel } from "@/shared/types";
import type { PayloadAction } from "@reduxjs/toolkit";
import { call, put, takeLatest } from "redux-saga/effects";
import { PARCELS_PAGE_SIZE, parcelsActions } from "./slice";
import type { FetchParcelsPayload } from "./types";

function* fetchParcels(action: PayloadAction<FetchParcelsPayload>) {
  const { filter, page } = action.payload;
  try {
    const data: Paginated<Parcel> = yield call(getParcels, {
      page,
      pageSize: PARCELS_PAGE_SIZE,
      // `all` is a UI value; the API filters only when a real status is sent.
      ...(filter === "all" ? {} : { status: filter }),
    });
    yield put(parcelsActions.fetchParcelsSuccess({ data, append: page > 1 }));
  } catch (error) {
    yield put(parcelsActions.fetchParcelsFailure(toApiError(error)));
  }
}

export function* parcelsSaga() {
  // takeLatest: switching filters quickly must not let a slow first response
  // overwrite the newer one.
  yield takeLatest(parcelsActions.fetchParcels.type, fetchParcels);
}
